import { render } from "./FirestormArena.vue?vue&type=template&id=1c2e66b3&scoped=true"
const script = {}

import "./FirestormArena.vue?vue&type=style&index=0&id=1c2e66b3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c2e66b3"]])

export default __exports__